import { render, staticRenderFns } from "./RsaFatturazioneModalEditComponent.vue?vue&type=template&id=2a4067e6"
import script from "./RsaFatturazioneModalEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaFatturazioneModalEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports